import { render, staticRenderFns } from "./edit-documents.vue?vue&type=template&id=cb2d5f1a&"
import script from "./edit-documents.vue?vue&type=script&lang=js&"
export * from "./edit-documents.vue?vue&type=script&lang=js&"
import style0 from "./edit-documents.vue?vue&type=style&index=0&id=cb2d5f1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports